<template>
  <h1>Some errors....</h1>
</template>
<script>
export default {
  name: "Error",
};
</script>
